import React from "react";
import styles from "./progress.module.css";

const HeaderItem = ({ active, passed, children }) => {
    return (
      <li
        className={`${active ? styles.active : passed ? styles.passed : ""} ${
          styles.HeaderItem
        }`}
        style={{whiteSpace: "nowrap"}}
      >
        {children}
      </li>
    );
  };

export default HeaderItem;